var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "import_task_wrap" }, [
    _c("div", { staticClass: "import_task_title" }, [
      _c("h2", [_vm._v("导入任务")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn" },
        [
          _c("el-button", { on: { click: _vm.cancelImport } }, [
            _vm._v("取消")
          ]),
          _vm._v(" "),
          _c("el-button", { on: { click: _vm.saveQuestion } }, [_vm._v("保存")])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "import_task_main" }, [
      _c(
        "div",
        { staticClass: "import_task_header" },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.conditionList } },
            [
              [
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isOpen,
                        expression: "isOpen"
                      }
                    ],
                    staticClass: "subject_name"
                  },
                  [_vm._v("科目：" + _vm._s(_vm.conditionList.subjectName))]
                )
              ],
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "search_item",
                  attrs: { placeholder: "请选择题型" },
                  on: { change: _vm.searchFn },
                  model: {
                    value: _vm.conditionList.questionType,
                    callback: function($$v) {
                      _vm.$set(_vm.conditionList, "questionType", $$v)
                    },
                    expression: "conditionList.questionType"
                  }
                },
                _vm._l(_vm.conditionList.questionTypeList, function(item, i) {
                  return _c("el-option", {
                    key: i,
                    attrs: { label: item.questiontypeName, value: item.id }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false"
                    }
                  ],
                  staticClass: "search_item",
                  attrs: {
                    placeholder: "请选择用途",
                    clearable: "",
                    disabled: true
                  },
                  on: { change: _vm.searchFn },
                  model: {
                    value: _vm.conditionList.purpose,
                    callback: function($$v) {
                      _vm.$set(_vm.conditionList, "purpose", $$v)
                    },
                    expression: "conditionList.purpose"
                  }
                },
                _vm._l(_vm.conditionList.purposeList, function(item, i) {
                  return _c("el-option", {
                    key: i,
                    attrs: { label: item.labelName, value: item.id }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "search_item",
                  attrs: { placeholder: "请选择难度", clearable: "" },
                  on: { change: _vm.searchFn },
                  model: {
                    value: _vm.conditionList.difficulty,
                    callback: function($$v) {
                      _vm.$set(_vm.conditionList, "difficulty", $$v)
                    },
                    expression: "conditionList.difficulty"
                  }
                },
                _vm._l(_vm.conditionList.difficultyList, function(item, i) {
                  return _c("el-option", {
                    key: i,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "search_item",
                  attrs: { placeholder: "请选择公司", clearable: "" },
                  on: { change: _vm.searchFn },
                  model: {
                    value: _vm.conditionList.company,
                    callback: function($$v) {
                      _vm.$set(_vm.conditionList, "company", $$v)
                    },
                    expression: "conditionList.company"
                  }
                },
                _vm._l(_vm.conditionList.companyList, function(item, i) {
                  return _c("el-option", {
                    key: i,
                    attrs: { label: item.name, value: item.id }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "search_item",
                  attrs: { placeholder: "请选择标签", clearable: "" },
                  on: { change: _vm.searchFn },
                  model: {
                    value: _vm.conditionList.tag,
                    callback: function($$v) {
                      _vm.$set(_vm.conditionList, "tag", $$v)
                    },
                    expression: "conditionList.tag"
                  }
                },
                _vm._l(_vm.conditionList.tagList, function(item, i) {
                  return _c("el-option", {
                    key: i,
                    attrs: { label: item.labelName, value: item.id }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "search_input",
                attrs: { placeholder: "请输入标题或题干", clearable: "" },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.searchFn.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.conditionList.question,
                  callback: function($$v) {
                    _vm.$set(_vm.conditionList, "question", $$v)
                  },
                  expression: "conditionList.question"
                }
              }),
              _vm._v(" "),
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.searchFn()
                      }
                    }
                  },
                  [_vm._v("查询")]
                )
              ]
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isOpen
        ? _c(
            "div",
            {
              staticClass: "import_task_main_left",
              style: "height:" + (_vm.windowHeight - 130) + "px"
            },
            [
              _c(
                "div",
                {
                  class:
                    "main_tree_title " + (_vm.materialData ? "" : "active"),
                  on: { click: _vm.selectAll }
                },
                [
                  _vm.materialData
                    ? _c("img", {
                        staticClass: "icon",
                        attrs: {
                          src: require("../../../../assets/image/sources/all.png"),
                          alt: ""
                        }
                      })
                    : _c("img", {
                        staticClass: "icon",
                        attrs: {
                          src: require("../../../../assets/image/sources/all-1.png"),
                          alt: ""
                        }
                      }),
                  _vm._v(" "),
                  _c("h3", [_vm._v("全部")])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "main_tree_content",
                  style: "height:" + (_vm.windowHeight - 163) + "px"
                },
                [
                  _c("el-tree", {
                    ref: "treeData",
                    attrs: {
                      data: _vm.treeData,
                      props: _vm.defaultProps,
                      "node-key": "id",
                      "default-expand-all": false,
                      "highlight-current": true,
                      "expand-on-click-node": false
                    },
                    on: { "node-click": _vm.handleNodeClick },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var node = ref.node
                            return _c(
                              "p",
                              { staticClass: "custom-tree-node" },
                              [_c("span", [_vm._v(_vm._s(node.label))])]
                            )
                          }
                        }
                      ],
                      null,
                      false,
                      271419056
                    )
                  })
                ],
                1
              )
            ]
          )
        : _c("div"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "import_task_main_right",
          style:
            (_vm.isOpen ? "width: calc(100% - 224px);" : "width: 100%;") +
            "height:" +
            (_vm.windowHeight - 130) +
            "px"
        },
        [
          _vm.isOpen
            ? _c("img", {
                staticClass: "close",
                attrs: {
                  src: require("../../../../../static/images/course/close.png"),
                  alt: ""
                },
                on: {
                  click: function($event) {
                    _vm.isOpen = !_vm.isOpen
                  }
                }
              })
            : _c("img", {
                staticClass: "open",
                attrs: {
                  src: require("../../../../../static/images/course/open.png"),
                  alt: ""
                },
                on: {
                  click: function($event) {
                    _vm.isOpen = !_vm.isOpen
                  }
                }
              }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "main_title" },
            [
              _vm.topics.length
                ? _c(
                    "el-checkbox",
                    {
                      attrs: { indeterminate: _vm.isIndeterminate },
                      on: { change: _vm.handleCheckAllChange },
                      model: {
                        value: _vm.checkAll,
                        callback: function($$v) {
                          _vm.checkAll = $$v
                        },
                        expression: "checkAll"
                      }
                    },
                    [_vm._v("全选")]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.topics.length > 0
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ],
                  ref: "question_testArea",
                  staticClass: "testArea",
                  style: "height:" + (_vm.windowHeight - 230) + "px"
                },
                _vm._l(_vm.topics, function(item, item_index) {
                  return _c("div", { key: item_index }, [
                    item.childCount === 0
                      ? _c(
                          "div",
                          {
                            staticClass: "questionInfo single_question",
                            class: { questionMask: !item.isShowMore }
                          },
                          [
                            _c(
                              "p",
                              [
                                _c(
                                  "el-checkbox-group",
                                  {
                                    staticClass: "single_topic_checkbox",
                                    on: {
                                      change: _vm.handleCheckedTopicChange
                                    },
                                    model: {
                                      value: _vm.checkedTopic,
                                      callback: function($$v) {
                                        _vm.checkedTopic = $$v
                                      },
                                      expression: "checkedTopic"
                                    }
                                  },
                                  [
                                    _c("el-checkbox", {
                                      key: item.id,
                                      attrs: { label: item.id }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "num" }, [
                                  _vm._v(
                                    _vm._s(
                                      (_vm.pageTotal.currentPage - 1) * 10 +
                                        (item_index + 1)
                                    ) + "、"
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "title_info title_border" },
                                  [
                                    _vm._v(
                                      "题型：" + _vm._s(item.questionTypeName)
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "title_info title_border" },
                                  [
                                    _vm._v(
                                      "难度：" +
                                        _vm._s(
                                          _vm._f("formatDiff")(item.difficulty)
                                        )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "title_info title_border" },
                                  [_vm._v("建议分数：" + _vm._s(item.score))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "title_info title_border" },
                                  [_vm._v("创建人：" + _vm._s(item.createName))]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "title_info" }, [
                                  _vm._v(
                                    "创建时间：" +
                                      _vm._s(
                                        _vm._f("formatTime")(item.createTime)
                                      )
                                  )
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("el-divider"),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "question_title" },
                              [
                                _c("span", [_vm._v(_vm._s(item.taskName))]),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !item.isShowMore,
                                        expression: "!item.isShowMore"
                                      }
                                    ],
                                    attrs: { type: "info", size: "mini" },
                                    on: {
                                      click: function($event) {
                                        item.isShowMore = !item.isShowMore
                                      }
                                    }
                                  },
                                  [
                                    _vm._v("展开"),
                                    _c("i", {
                                      staticClass: "el-icon-caret-bottom"
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.isShowMore,
                                        expression: "item.isShowMore"
                                      }
                                    ],
                                    attrs: { type: "info", size: "mini" },
                                    on: {
                                      click: function($event) {
                                        item.isShowMore = !item.isShowMore
                                      }
                                    }
                                  },
                                  [
                                    _vm._v("收起"),
                                    _c("i", {
                                      staticClass: "el-icon-caret-top"
                                    })
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticClass:
                                "div_content editorShowArea ql-editor",
                              domProps: {
                                innerHTML: _vm._s(item.questionContent)
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "answer" }, [
                              _c(
                                "p",
                                [
                                  _vm._v("【知识点】\n                  "),
                                  item.materials.length > 0
                                    ? _vm._l(item.materials, function(
                                        material,
                                        mat_index
                                      ) {
                                        return _c(
                                          "span",
                                          { key: mat_index },
                                          [
                                            material
                                              ? _c(
                                                  "el-tag",
                                                  {
                                                    attrs: {
                                                      title: material.name
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(material.name)
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      })
                                    : _vm._e()
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                [
                                  _vm._v("【用途】\n                  "),
                                  _vm._l(item.labels, function(
                                    label,
                                    label_index
                                  ) {
                                    return _c(
                                      "el-tag",
                                      {
                                        key: label_index,
                                        attrs: { title: label.labelName }
                                      },
                                      [_vm._v(_vm._s(label.labelName))]
                                    )
                                  })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              item.companyNameUp
                                ? _c(
                                    "p",
                                    [
                                      _vm._v("【公司】\n                  "),
                                      _c(
                                        "el-tag",
                                        {
                                          staticStyle: {
                                            "vertical-align": "middle"
                                          }
                                        },
                                        [_vm._v(_vm._s(item.companyNameUp))]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.personLabels.length > 0
                                ? _c(
                                    "p",
                                    [
                                      _vm._v("【标签】\n                  "),
                                      _vm._l(item.personLabels, function(
                                        personLabel,
                                        personLabel_index
                                      ) {
                                        return _c(
                                          "el-tag",
                                          {
                                            key: personLabel_index,
                                            attrs: {
                                              title: personLabel.labelName
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(personLabel.labelName)
                                            )
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.attachmentList.length > 0
                                ? _c(
                                    "p",
                                    [
                                      _vm._v("【附件】\n                  "),
                                      _vm._l(item.attachmentList, function(
                                        attachment,
                                        attachment_index
                                      ) {
                                        return _c(
                                          "span",
                                          { key: attachment_index },
                                          [
                                            attachment
                                              ? _c(
                                                  "el-tag",
                                                  {
                                                    attrs: {
                                                      title: attachment.name
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(attachment.name)
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("p", { staticClass: "lineH20" }, [
                                _vm._v("【备注】\n                  "),
                                _c(
                                  "span",
                                  { staticStyle: { "margin-right": "10px" } },
                                  [
                                    _vm._v(
                                      "修改人：" +
                                        _vm._s(
                                          item.updateName
                                            ? item.updateName
                                            : "--"
                                        )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "修改时间：" +
                                      _vm._s(
                                        item.updateTime ? item.updateTime : "--"
                                      )
                                  )
                                ])
                              ])
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                }),
                0
              )
            : _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ],
                  staticClass: "no_content",
                  style: "height:" + (_vm.windowHeight - 230) + "px"
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("../../../../../static/images/wujieguo.png"),
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("p", [_vm._v("暂无内容")])
                ]
              ),
          _vm._v(" "),
          _c("Pagination", {
            attrs: {
              currentpage: _vm.pageTotal.currentPage,
              limit: _vm.pageTotal.pageSize,
              total: _vm.pageTotal.total,
              layout: "sizes, prev, pager, next, jumper",
              small: true
            },
            on: {
              handleCurrentChange: _vm.handleCurrentChange,
              handleSizeChange: _vm.handleSizeChange
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60cb3a80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60cb3a80","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/course/components/importTask.vue
// module id = null
// module chunks = 